import $ from "jquery";
import "slick-carousel";

const timeline = () => {
  const init = () => {
    slick();
  };

  const slick = () => {
    const el = {
      slider: ".js-Timeline__Slider",
      navs: ".js-Timeline__Navigation",
      indicator: ".mi-Timeline__DesktopIndicator",
    };

    if ($(el.slider || el.navs).length === 0) return;

    $(el.slider).slick({
      dots: false,
      arrows: false,
      infinite: false,
      adaptiveHeight: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: el.navs,
    });

    $(el.navs).slick({
      slidesToShow: 7,
      infinite: false,
      speed: 1000,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: el.slider,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

    // Make indicator move as the navs is
    $(el.slider).on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var left_val,
          li_wid = parseInt(
            $(".js-Timeline__Navigation .slick-slide").css("width")
          );
        var currentSlideIndex = nextSlide;

        left_val = currentSlideIndex * li_wid + 52;

        $(el.indicator).css({
          left: left_val,
        });
      }
    );
  };

  init();
};

timeline();
